/**
 * The parsed row of each sampled population item, saved with the run so the AI service can match the rows against
 * evidence for a population of any format (spreadsheet, Word, image): {ref: {column: value, _row_number}}.
 */
export function selectedRowData(parseResult, selected) {
  const chosen = new Set((selected || []).map((s) => String(typeof s === 'string' ? s : s?.record_ref ?? s).trim()));
  const out = {};
  (parseResult?.items_detail || []).forEach((d) => {
    const ref = String(d?.ref ?? '').trim();
    if (!ref || !chosen.has(ref)) return;
    out[ref] = { ...(d.fields || {}), ...(d.row_number != null ? { _row_number: d.row_number } : {}), ...(d.page_number != null ? { _page_number: d.page_number } : {}) };
  });
  return out;
}
